<div [ngClass]="panelClass" data-test="confirmation-dialog" class="confirmation-dialog" (keyup)="onKeyUp($event)" (keydown.enter)="onEnterDown($event)">
  <div class="dialog-title">
    <p>
      <span>{{ messageTitle | translate }}</span>
    </p>
  </div>
  <div class="dialog-content" data-test="content-text">
    <span [innerHtml]="messageText | translate: { value: value, type: type }" (click)="onContentClick($event)"></span>
    @if (showDontAskAgain) {
      <div class="dont-ask">
        <mat-checkbox [(ngModel)]="dontAskAgain">Don't ask again</mat-checkbox>
      </div>
    }
  </div>
  <div class="actions-row">
    @if (!cancelButtonIsNotRequired) {
      <button data-test="no-btn" mat-stroked-button (click)="cancel($event)" class="secondary-button cancel-button">
        {{ cancelButtonText || "generic.no" | translate }}
      </button>
    }
    <button data-test="yes-btn" mat-stroked-button (click)="submit({ event: $event })" class="primary-button proceed-button">
      {{ proceedButtonText || "generic.yes" | translate }}
    </button>
    @if (proceedButtonText_2) {
      <span class="or-divider">OR</span>
      <button data-test="yes-btn" mat-stroked-button (click)="submit({ event: $event, secondary: true })" class="primary-button proceed-button">
        {{ proceedButtonText_2 || "generic.yes" | translate }}
      </button>
    }
  </div>
</div>
